/** Stable column choice for single/multi choice grids. */
export type GridChoiceOption = {
  id: string;
  label: string;
};

export function nextGridChoiceId(): string {
  return `c_${crypto.randomUUID().replace(/-/g, '').slice(0, 8)}`;
}

export function createGridChoice(label = ''): GridChoiceOption {
  return { id: nextGridChoiceId(), label };
}

/** Legacy string `"Correct"` → `{ id: "Correct", label: "Correct" }`. */
export function hydrateGridChoice(raw: unknown): GridChoiceOption | null {
  if (typeof raw === 'string') {
    const label = raw.trim();
    if (!label) {
      return null;
    }
    return { id: label, label };
  }
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) {
    return null;
  }
  const obj = raw as { id?: unknown; label?: unknown; value?: unknown };
  const label =
    typeof obj.label === 'string'
      ? obj.label
      : typeof obj.value === 'string'
        ? obj.value
        : '';
  const id =
    typeof obj.id === 'string' && obj.id.trim()
      ? obj.id.trim()
      : label.trim();
  if (!id && !label.trim()) {
    return null;
  }
  return { id: id || label.trim(), label };
}

export function hydrateGridChoices(raw: unknown): GridChoiceOption[] {
  if (!Array.isArray(raw)) {
    return [];
  }
  return raw
    .map((item) => hydrateGridChoice(item))
    .filter((item): item is GridChoiceOption => item != null);
}

export function defaultGridChoices(labels: readonly string[]): GridChoiceOption[] {
  return labels.map((label) => createGridChoice(label));
}
